import React from 'react';
import { useSelector } from 'react-redux';
import {
  Alert, Container
} from 'reactstrap';

import { actions as NotificationActions, selectors as NotificationSelectors } from './store/slices/notification'

export const NotificationLayer = ({ children, ...rest }: any) => {

  const notification = useSelector(NotificationSelectors.getNotification)
  return (
    <>
      { children}
      {notification.visible &&
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 80, zIndex: 10 }}>
          <Container>
            <Alert color={notification.type}>
              {notification.message}
            </Alert>
          </Container>
        </div>
      }
    </>
  )
}